<template>
    <div>
        <docs-manager
                v-if="event"
                :event="event"
                ref="docsManager"
                :docs="documents" />
    </div>
</template>

<script>

    import {ApiUtils} from '@/utils/ApiUtils'
    import {getFakeAvatar} from '@/utils/Common'
    import {mapState} from 'vuex'
    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'

    export default {
        props:{
            visible: {
                type: Boolean,
                default: false
            },
            event:{
                type: Object,
            }
        },
        components: {
            DocsManager: () => import('@/components/appointments/attention/DocsManager')
        },
        mounted(){
            var vm = this
            if(!!vm.event){
               vm.connectSocket()
            }
        },
        beforeDestroy(){
            var vm = this
            leaveChannel(`appointment.${vm.event.id}`)
        },
        data (vm) {
            return {
                loadingDocAttach: false,
                drawer: vm.visible,
                documents: vm.event && vm.event.appointment_documents || [],
                items: [
                    { title: 'Documentos', icon: 'fa-paperclip', action: vm.showDocsManager },
                    { title: 'Indicaciones', icon: 'fa-clipboard', action: () => {} },
                    //{ title: 'Boleta', icon: 'fa-file-invoice-dollar', action: () => {} }
                ],
                links: ['Home', 'Contacts', 'Settings'],
                mini: true,
                right: null
            }
        },
        methods:{
            connectSocket(){
                var vm = this
                subscribeToPrivateChannelEvents(`appointment.${vm.event.id}`, {
                    'AppointmentDocumentUploaded': vm.onDocumentUploaded,
                    'AppointmentDocumentDeleted': vm.onDocumentDeleted,
                })
            },
            onDocumentDeleted({document}){
              const vm = this
              const index = vm.documents.findIndex(doc => doc.id === document.id)
              if(index !== -1){
                vm.documents.splice(index, 1)
              }
            },
            onDocumentUploaded({document}){
                var vm = this
                if(document.user.id !== vm.currentUser.id){
                    vm.$store.commit('showSnackBar', {
                        text: 'Se ha cargado un nuevo documento',
                        color: 'success'
                    })
                }
                const index = vm.documents.findIndex(doc => doc.id === document.id)
                if(index === -1){
                  vm.documents.push(document)
                }
            },
            showDocsManager(){
                var vm = this
                vm.$refs.docsManager.show()
            }
        },
        computed:{
            ...mapState(['currentUser']),
            avatar(){
                var vm = this
                return vm.event.client.avatar || getFakeAvatar(vm.event.client.gender)
            },
            model:{
                get(){
                    var vm = this
                    return vm.drawer
                },
                set(val){
                    var vm = this
                    vm.drawer = val
                }
            }
        },
        watch:{
            event(val, oldVal){

                if(oldVal){
                    leaveChannel(`appointment.${oldVal.id}`)
                }

                if(val){
                    this.documents = val.appointment_documents
                    leaveChannel(`appointment.${val.id}`)
                    this.connectSocket()
                }else{
                    this.documents = []
                }
            },
            visible(val){
                this.drawer = val
            }
        }
    }
</script>